import { useQuery } from '@tanstack/react-query'
import { getAddressSuggestions } from '@/infra/services'

export const useGetAddressSuggestions = (query: string) =>
  useQuery(['addressSuggestions', query], () => getAddressSuggestions(query), {
    enabled: query.trim().length >= 3,
    keepPreviousData: true,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false
  })
